export const resolvePublicPath = (publicUrl?: string): string => {
  if (!publicUrl) {
    return '/';
  }

  const stripped = publicUrl.replace(/^https?:\/\/[^/]+/i, '');
  const normalized = stripped === '.' || stripped === './' ? '/' : stripped;

  if (!normalized || normalized === '/') {
    return '/';
  }

  const trimmed = normalized.endsWith('/') && normalized !== '/' ? normalized.slice(0, -1) : normalized;
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getRouterBasename = (): string | undefined => {
  const resolved = resolvePublicPath(process.env.PUBLIC_URL);
  console.log("Resolved public path:", resolved);
  if (!resolved || resolved === '/') {
    return undefined;
  }
  return resolved;
};

export const withBasePath = (path: string): string => {
  const base = resolvePublicPath(process.env.PUBLIC_URL);
  const normalizedBase = !base || base === '/' ? '' : base;

  if (!path || path === '/') {
    return normalizedBase || '/';
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
};
